import React from 'react';
import PropTypes from 'prop-types';

import {Paper, Stack} from 'views/components';
import {Tab, TabContext, TabList, TabPanel} from 'views/components';
import {translate} from 'views/module';

import CaregiverHeader from './header/CaregiverHeader';
import Correspondances from './correspondances/Correspondances';
import Schedule from './schedule/Schedule';
import ClientConnection from './client_connection/ClientConnection';
import ClientChats from './caregiver_chat/ClientChats';
import Payment from './payment/Payment';
import Biography from './biography/Biography';
import Review from './review/Review';
import Interviews from './interviews/Interviews';
import Tasks from './tasks/TaskList';

const CaregiverFeed = (props) => {
  const {
    feedTab,
    setFeedTab,
  } = props;

  const handleChange = (event, newValue) => {
    setFeedTab(newValue);
  };

  return (
    <Paper >
      <Stack>
        <CaregiverHeader
          {...props}
        />
        <TabContext
          value={feedTab}
        >
          <TabList
            onChange={handleChange}
            sx={{borderBottom: 1, borderColor: 'divider'}}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={translate('caregiver.CaregiverDetail.Correspondance.Title')}
              value="CORRESPONDANCE"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.Biography.Title')}
              value="BIOGRAPHY"
            />
            <Tab
              label={translate('client.ClientDetail.Tasks.Title')}
              value="TASKS"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.Scheduling.Title')}
              value="SCHEDULING"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.ClientConnections.Title')}
              value="CLIENTS"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.ClientConnections.Chat.TabTitle')}
              value="CHATS"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.Payment.Title')}
              value="PAYMENT"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.Reviews.Title')}
              value="REVIEWS"
            />
            <Tab
              label={translate('caregiver.CaregiverDetail.Interviews.Title')}
              value="INTERVIEWS"
            />
          </TabList>
          <TabPanel
            value={'CORRESPONDANCE'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Correspondances
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'BIOGRAPHY'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Biography
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'TASKS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Tasks
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'SCHEDULING'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Schedule
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'CLIENTS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <ClientConnection
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'CHATS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <ClientChats
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'PAYMENT'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Payment
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'REVIEWS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Review
              {...props}
            />
          </TabPanel>
          <TabPanel
            value={'INTERVIEWS'}
            sx={{
              m: 0, p: 0,
            }}
          >
            <Interviews
              {...props}
            />
          </TabPanel>
        </TabContext>
      </Stack>
    </Paper>
  );
};
CaregiverFeed.propTypes = {
  caregiverRn: PropTypes.string.isRequired,
  caregiverData: PropTypes.object.isRequired,
  feedTab: PropTypes.string.isRequired,
  setFeedTab: PropTypes.func.isRequired,
};

export default React.memo(CaregiverFeed);
